const BASE = process.env.REACT_APP_BACKEND_URL;

async function parseJsonOrThrow(resp, fallbackMessage) {
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || fallbackMessage);
  }
  return resp.json();
}

async function postJson(path, body, token, fallbackMessage) {
  const resp = await fetch(`${BASE}/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  return parseJsonOrThrow(resp, fallbackMessage);
}

/** All questions for a theme: [{ id, question_name, category }]. */
export async function listQuestions({ themeName, organizationId, sessionId, token }) {
  const data = await postJson(
    "listQuestions",
    { themename: themeName, organizationId, sessionId },
    token,
    "Failed to load questions"
  );
  return data.questions || [];
}

/** Add or edit one question, mirroring old/admin/add-question-upload.php. */
export async function saveQuestion({ themeName, token, action, editId, question }) {
  return postJson(
    "saveQuestion",
    {
      themename: themeName,
      action,
      edit_id: editId || undefined,
      question_name: question.question_name,
      category: question.category,
    },
    token,
    "Failed to save question"
  );
}

export async function deleteQuestion({ themeName, id, token }) {
  return postJson("deleteQuestion", { themename: themeName, id }, token, "Failed to delete question");
}

/** Replaces every question for the theme (old/admin/process.php). */
export async function importQuestionsCsv({ themeName, rows, token }) {
  return postJson("importQuestionsCsv", { themename: themeName, rows }, token, "Failed to import CSV");
}
